import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import { getToken } from '@/utils/auth'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    tokenInfo: getToken(),
    classinfo: {},
    courseId: sessionStorage.getItem('courseId') || '', //课程id
    coursename: sessionStorage.getItem('coursename') || '',
    class: JSON.parse(sessionStorage.getItem('classinfo')) || '',
    routerlist: [],
    Examtype: JSON.parse(sessionStorage.getItem('Examtype')) || '',
    correct: JSON.parse(localStorage.getItem('correct')) || '',
    correctdea: JSON.parse(localStorage.getItem('correctdea')) || '',
  },
  mutations: mutations,
  actions: actions,
})

export default store
